module.exports = __webpack_public_path__ + "img/thumbtack.57ef19f7.svg";